module.exports = __webpack_public_path__ + "static/rf-screenshot-discover-a566c45e9bfb67e1dd02022227e77afb.jpg";